import React from 'react';
import styled from 'styled-components';
import { useMsal } from '@azure/msal-react';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-color: #f5f5f5;
`;

const Content = styled.div`
  background-color: white;
  border-radius: 4px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  padding: 2rem;
  width: 100%;
  max-width: 500px;
  text-align: center;
`;

const Title = styled.h2`
  color: #d32f2f;
  margin-bottom: 1rem;
`;

const Message = styled.p`
  color: #666;
  margin-bottom: 1.5rem;
  line-height: 1.5;
`;

const Button = styled.button`
  background-color: #5eb2ff;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 0.75rem 1.5rem;
  font-size: 1rem;
  cursor: pointer;
  margin: 0.5rem;

  &:hover {
    background-color: #4a90e2;
  }
`;

const ButtonSecondary = styled(Button)`
  background-color: #757575;

  &:hover {
    background-color: #616161;
  }
`;

interface UnauthorizedProps {
  userName?: string;
}

const Unauthorized: React.FC<UnauthorizedProps> = ({ userName }) => {
  const { instance } = useMsal();

  const handleLogout = () => {
    instance.logoutRedirect();
  };

  const handleRetry = () => {
    window.location.reload();
  };

  return (
    <Container>
      <Content>
        <Title>Access Denied</Title>
        <Message>
          {userName ? (
            <>
              You are signed in as <strong>{userName}</strong>, but your account
              does not have permission to access this application.
            </>
          ) : (
            <>
              Your account does not have permission to access this application.
            </>
          )}
        </Message>
        <Message>
          Please contact your administrator to request access.
        </Message>
        <div>
          <Button onClick={handleRetry}>
            Retry
          </Button>
          <ButtonSecondary onClick={handleLogout}>
            Sign Out
          </ButtonSecondary>
        </div>
      </Content>
    </Container>
  );
};

export default Unauthorized;
